import type { ThemeConfig } from "antd";

const customTheme: ThemeConfig = {
  token: {
    fontSize: 12,
    borderRadius: 3,
    sizeStep: 4,
    wireframe: true,
  },
  components: {
    Space: {
      padding: 12,
      paddingLG: 16,
      paddingXS: 18,
      algorithm: true,
    },
    Menu: {
      itemSelectedBg: "rgb(19,194,194)",
    },
    Drawer: {
      padding: 12,
      paddingLG: 16,
      footerPaddingInline: 12,
    },
  },
};

export default customTheme;
